module.exports = __webpack_public_path__ + "img/MC33.c48dba14.png";